import { render } from "./InstallBaseMap.vue?vue&type=template&id=67d0e058&scoped=true"
import script from "./InstallBaseMap.vue?vue&type=script&lang=js"
export * from "./InstallBaseMap.vue?vue&type=script&lang=js"

import "./InstallBaseMap.vue?vue&type=style&index=0&id=67d0e058&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d0e058"]])

export default __exports__